import { Button, Descriptions, Dropdown, Popconfirm, Table, Tabs } from "antd";
import { useNavigate, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

export default function Mansion() {
  const data = useRouteLoaderData("mansion");
  const navigate = useNavigate();

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli mansione"
        secondary={`ID: ${data.id}`}
        extra={
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "delete",
                  danger: true,
                  icon: <DeleteOutlined />,
                  label: (
                    <Popconfirm
                      title="Conferma rimozione"
                      description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      onConfirm={() => api.mansion.delete(data.id).then(() => navigate(".."))}
                    >
                      Elimina
                    </Popconfirm>
                  ),
                },
              ],
            }}
          >
            <Button aria-label="Azioni mansione" icon={<MoreOutlined />} />
          </Dropdown>
        }
      />
      <Descriptions
        layout="vertical"
        column={3}
        colon={false}
        title={
          <>
            Informazioni generali
            <Button
              type="link"
              aria-label="Modifica mansione"
              icon={<EditOutlined />}
              onClick={() => navigate("edit")}
            />
          </>
        }
        items={[{ key: "name", label: "Nome", children: data.name }]}
      />
      <Tabs
        items={[
          {
            key: "courses",
            label: "Corsi richiesti",
            children: (
              <Table
                rowKey="id"
                pagination={false}
                dataSource={data.requiredCourseTypes ?? []}
                locale={{ emptyText: "Nessun corso richiesto" }}
                columns={[
                  { title: "ID", dataIndex: "id", key: "id", width: 100 },
                  { title: "Nome", dataIndex: "title", key: "title" },
                ]}
              />
            ),
          },
          {
            key: "dpis",
            label: "DPI richiesti",
            children: (
              <Table
                rowKey="id"
                pagination={false}
                dataSource={data.requiredDpis ?? []}
                locale={{ emptyText: "Nessun DPI richiesto" }}
                columns={[
                  { title: "ID", dataIndex: "id", key: "id", width: 100 },
                  { title: "Nome", dataIndex: "name", key: "name" },
                ]}
              />
            ),
          },
        ]}
      />
    </div>
  );
}
